<template>
    <Select2 :options="priceTypesForSelect2" v-model="price_type"
             :settings="{ width: '150px', minimumResultsForSearch: -1 }"/>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        computed: {
            ...mapGetters([
                'priceTypesForSelect2',
            ]),
            price_type: {
                get () {
                    return this.$store.state.plans.filters.price_type;
                },
                set (value) {
                    this.$store.dispatch('updatePriceType', value);
                }
            },

        }
    }
</script>